import { render } from "./Carousel.vue?vue&type=template&id=b04df90a&scoped=true&ts=true"
import script from "./Carousel.ts?vue&type=script&lang=ts"
export * from "./Carousel.ts?vue&type=script&lang=ts"

import "./Carousel.scss?vue&type=style&index=0&id=b04df90a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04df90a"]])

export default __exports__